import { type Role } from "shared/Api/Role";
import { type GradeLevel } from "shared/Api/GradeLevel";

export enum BuildingSettingType {
	BOOK_QUIZZES = 1,
	AR_QUIZ = 7,
	BOOK_REVIEWS = 2,
	LITERACY_CENTER = 8,
	READALOUD = 9
}

export type MyonEnv = {
	chromeAppId: string;
	mobileApiDomain: string;
	assetCdn: string;
	booksCdn: string;
	thumbsCdn: string;
	version: string;
	language: string,
	region: string,
	keepAliveCookieName: string;
	timeout: {
		keepaliveInterval: number;
		timeout: number;
		timeToRespond: number;
	};
	bandwidthTest: {
		cacheTTL: number;
		cacheCookie: string;
		downlinkThreshold: number;
		requestThreshold: number;
	};
	login: {
		buildingSearch: {
			endpoint: string;
			prioritizeHost: boolean;
			canonicalHost: string;
		}
	};
};


export type ValidationAwareMyonEnv = MyonEnv & {
	validation: {
		usernameMinLength: number;
		usernameMaxLength: number;
		usernameIllegalCharacters: string;
		studentPasswordMinLength: number;
		personnelPasswordMinLength: number;
		passwordSpecialCharacters: string;
		maxProjectStudents: number;
	};
};

export type UserAuthorizedMyonEnv = ValidationAwareMyonEnv & {
	dictionary?: {
		audio: string;
		search: string;
		lang: string;
		translate?: string;
	};
	canManageBookGradeLevelRestrictions: boolean,
	signingEndpoint: string;
	signBookAssetCookies: boolean;
	signBookAssetPaths: boolean;
	trackerNewsEndpoint: string | null;
	trackerPageEventEndpoint: string | null;
	auth: {
		isLowerGrade: boolean;
		userId: number;
		username: string;
		userMyonId: string;
		roleId: Role;
		gradeLevelId: GradeLevel;
		buildingId: number;
		buildingMyonId: string;
		accountId: number;
		accountMyonId: string;
		permissionIds: number[];
		buildingSettings: BuildingSettingType[];
		languageIds: number[];
		isDemoStudent: boolean;
	};
};

export function isEnvValidationAware(env: MyonEnv): env is ValidationAwareMyonEnv {
	return "validation" in env;
}

export function isEnvUserAuthorized(env: MyonEnv): env is UserAuthorizedMyonEnv {
	return "auth" in env;
}
